import { render, staticRenderFns } from "./IndexSeven.vue?vue&type=template&id=05e5472a&"
import script from "./IndexSeven.vue?vue&type=script&lang=js&"
export * from "./IndexSeven.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports